import { render, staticRenderFns } from "./editCoach.vue?vue&type=template&id=99d68338"
import script from "./editCoach.vue?vue&type=script&lang=js"
export * from "./editCoach.vue?vue&type=script&lang=js"
import style0 from "./editCoach.vue?vue&type=style&index=0&id=99d68338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports